module.exports = __webpack_public_path__ + "static/media/galleryImg30.83379650.jpg";